import { IAddOnItem } from '@/services/types/quote/IAddons';

/**
 * Three-step fallback chain for the items payload of POST /quotes:
 * 1. explicit items passed to the thunk by the caller
 * 2. items currently on the live quote (state.quote.data.addons)
 * 3. items in the listing-stage addon slice (state.addons.addons)
 *
 * Step 3 matters when an in-flight race response just wiped the live quote.
 * Without it, a subsequent getQuote() call would POST without items and the
 * user's checkbox selections would silently drop off the bill.
 */
export const resolveAddonItems = (
  explicit: IAddOnItem[] | undefined,
  fromQuote: IAddOnItem[] | undefined,
  fromSlice: IAddOnItem[] | undefined,
): IAddOnItem[] | undefined => explicit ?? fromQuote ?? fromSlice;
